import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { decryptAES } from '../../../utils/Encryption';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import SwalServices from '../../../services/swalServices/SwalServices';
import { WoOrderReceivePopup } from './WoOrderReceiveTable';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import CommonServices from '../../../services/axiosServices/apiServices/CommonServices';
import moment from 'moment';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import { permission } from '../../../utils/enums/ValidationMessage';
// import { get } from 'react-scroll/modules/mixins/scroller';

export default class WoOrderReceive extends Component {

    constructor(props) {
        super(props)
        this.transactionStockServices = new TransactionStockServices();
        this.accountTransactionServices = new AccountTransactionServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.commonServices = new CommonServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            isModalOpen: false,
            isSaving: false,
            isChallanGenerated: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColdefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            companyName: "",
            workObject: {
                idWOOrderRecv: 0,
                updateStatus: 0,
                woRecvNo: '',
                woRecvDate: '',
                idCategory: 1,
                categoryList: [{
                    value: 1,
                    label: 'PARTY WORK ORDER'
                },
                {
                    value: 2,
                    label: 'INTERNAL WORK ORDER'
                }],
                idWoType: 1,
                woTypeList: [
                    {
                        value: 1,
                        label: 'INTRASTATE'
                    },
                    {
                        value: 2,
                        label: 'INTERSTATE'
                    }
                ],
                deliveryDate: '',
                idPartyAccount: '',
                customerList: [],
                idDelivery: '',
                deliveryList: [],
                personName: '',
                idWoPrioraty: 2,
                WoPrioratyList: [
                    {
                        value: 1,
                        label: 'LOW'
                    },
                    {
                        value: 2,
                        label: 'MEDIUM'
                    },
                    {
                        value: 2,
                        label: 'HIGH'
                    }
                ],
                address: "",
                delAdress: "",
                idEmployee: "",
                authEmpList: [],
                transporter: "",
                poNo: "",
                poDate: "",
                idFinancialYear: "",
                contactPerson: "",
                email: "",
                contactNo: "",
            },
            isSelectItemPopUp: false,
            itemObject: {
                idWOOrderRecvItems: 0,
                drawingNo: "",
                idCategory: 1,
                itemCategoryList: [
                    {
                        value: 1,
                        label: 'RAW MATERIAL'
                    },
                    {
                        value: 2,
                        label: 'FINISHED GOODS'
                    },
                    {
                        value: 3,
                        label: 'SEMI FINISHED'
                    },
                    {
                        value: 4,
                        label: 'SCRAP MATERIAL'
                    }
                ],
                idItem: "",
                itemIdLabel: "",
                itemList: [],
                unit: "",
                quantity: "",
                rate: "",
                amount: "",
                discount: "",
                discountAmt: "",
                chargeAmt: "",
                total: "",
                idTaxGroup: "",
                taxList: [],
                sgst: "",
                cgst: "",
                igst: "",
                sgstAmt: "",
                cgstAmt: "",
                igstAmt: "",
                taxAmt: "",
                netTotal: "",
                remarks: "",
                deleteItemsList: [],
            },
            selectItemColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemCategoryDesc",
                    headerName: "Item Category Desc",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            paymentDetails: {
                totalQty: "",
                totalAmt: "",
                extraCharges: "",
                disAmt: "",
                taxableAmt: "",
                taxAmt: "",
                totalWithTax: "",
                adjustableAmt: "",
                finalAmt: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForWork: {
                woRecvDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                idPartyAccount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "customer"
                        ),
                    },
                ],
            },
            validationRules: {
                idItem: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "item name"
                        ),
                    },
                ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
                idTaxGroup: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "tax group"
                        ),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId != null) {
                this.setState({ urlId: urlId });
            }
        }
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.USP_GetAllUsers();
                this.getMaster_TaxStructure();
                this.usp_Master_PartyAccountSelect();
            }, () => {
                if (this.gridApi) {
                    this.gridApi.hideOverlay();
                }
            });
        } else {
        }
        setTimeout(() => {
        }, 100)
    }

    USP_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "WO Order Receive",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: this.state.idUser,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            // width: this.getPinnedWidth(key),
                            hide: ["idwoOrderRecv", "idPartyAccount", "sR.No"].includes(key),
                            pinned: ["sR.No", "inwardNo", "gatePassNo", "inwardDate", "vendor"].includes(key) ? "left" : null,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.includes("woRecvDate") || key.includes("poDate") || key.includes("woRecvDate")
                                ? (params) => {
                                    if (!params.value) return "";
                                    return moment(params.value).format("DD-MM-YYYY");
                                }
                                : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "WO Order Receive",
                            colName: colName
                        }, () => {
                            this.procSelectAllRecord2GridviewSP(id);
                            this.setPermissions(permissions);
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            } else {
                if (this.gridApi) {
                    this.gridApi.hideOverlay();
                    this.gridApi.showNoRowsOverlay();
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "woRecvNo": window.innerWidth * 0.04,
            "woRecvDate": window.innerWidth * 0.07,
            "customer": window.innerWidth * 0.2,
            "poNo": window.innerWidth * 0.05,
            "totalQty": window.innerWidth * 0.06,
            "TotalAmt": window.innerWidth * 0.06,
            "extraCharges": window.innerWidth * 0.06,
            "discount": window.innerWidth * 0.06,
            "taxAmt": window.innerWidth * 0.06,
            "finalAmt": window.innerWidth * 0.06,
            "status": window.innerWidth * 0.08,
            "woClosed": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id) => {
        let request = {
            id: id,
            formname: "WO Order Receive",
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            minWidth: this.getColumn2Width(key) !== undefined ? this.getColumn2Width(key) : window.innerWidth * 0.06,
                            // pinned: this.table2PinnedWidth(key) ? "left" : null,
                            // width: this.table2ColWidth(key),
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    } else {
                        this.setState({
                            table2Data: [],
                            table2ColDefs: [],
                            isTable2Expanded: false
                        });
                    }
                }
            });
        }
    }
    getColumn2Width = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.11,
            "itemCategory": window.innerWidth * 0.16,
            "itemName": window.innerWidth * 0.18,
            "quantity": window.innerWidth * 0.05,
            "rate": window.innerWidth * 0.05,
            "taxableAmt": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.05,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.05,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.05,
            "igstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    getMaster_TaxStructure = () => {
        this.transactionStockServices.getMaster_TaxStructure().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.itemObject;
                data.taxList = allData.map((x) => ({
                    value: x.idTaxStructure,
                    label: x.taxStructureName,
                }));
                this.setState({
                    itemObject: data
                });
            }
            this.getMasterItemSelectbyIDVendorwiseRateForWoOrderRecv()
        });
    }

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idwoOrderRecv);
    };

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));
                    let workObject = this.state.workObject;
                    workObject.customerList = dynamicData;
                    workObject.deliveryList = dynamicData;
                    this.setState({ workObject: workObject });
                    this.setState({ partyAccountList: dynamicData }, () => {
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                }
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.transactionStockServices.getInvoiceCountForWoOrderReceive(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let total = response.responseItem.responseContent[0].count + 1;

                let formatted = '';
                if (total.toString().length === 1) {
                    formatted = '00' + total;
                } else if (total.toString().length === 2) {
                    formatted = '0' + total;
                } else {
                    formatted = total.toString();
                }
                let workObject = this.state.workObject
                workObject.woRecvNo = formatted
                workObject.woRecvDate = moment().format("YYYY-MM-DD");
                this.setState({ workObject: workObject, isChallanGenerated: false }, () => {
                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.setState({ itemRowData: [] })
                    })
                })
            }
        });
    };

    getMasterItemSelectbyIDVendorwiseRateForWoOrderRecv = () => {
        let request = [
            this.state.idCompany,
            this.state.itemObject.itemCategoryList?.find(x => x.value === this.state.itemObject.idCategory)?.label,
            this.state.workObject.idPartyAccount
        ];
        this.transactionStockServices.getMasterItemSelectbyItemTypeVendorwise(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.itemObject;
                data.itemList = allData;
                this.setState({
                    itemObject: data
                });
            } else {
            }
        });
    }

    // getMasterItemSelectbyIDVendorwiseRate = () => {
    //     let request = this.state.itemObject.idItem;
    //     this.masterEntryServices.getItemMasterSelectbyID(request).then((response) => {
    //         if (response.statusCode === 200 && response.responseItem !== null) {
    //             let allData = response.responseItem.responseContent[0];
    //             let data = this.state.itemObject;
    //             data.drawingNo = allData.drawingNo;
    //             data.rate = allData.itemRate;
    //             data.idTaxGroup = allData.idTaxGroup;
    //             data.unit = allData.rateOn;
    //             this.setState({
    //                 itemObject: data
    //             }, () => {
    //                 this.getTaxStructureSelectbyID();
    //             });
    //         } else {
    //         }
    //     });
    // }

    getMasterItemSelectbyIDVendorwiseRate = () => {
        // let request = this.state.itemObject.idItem;
        let request = [
            this.state.itemObject.idItem,
            this.state.workObject.idPartyAccount
        ];
        this.transactionStockServices.getMasterItemSelectbyIDVendorwiseRate(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent[0];
                let data = this.state.itemObject;
                data.drawingNo = allData.drawingNo;
                data.rate = allData.finalItemRate ? allData.finalItemRate : allData.itemRate;
                data.idTaxGroup = allData.idTaxGroup;
                data.unit = allData.rateOn;
                this.setState({
                    itemObject: data
                }, () => {
                    this.getTaxStructureSelectbyID();
                });
            } else {
            }
        });
    }

    getPartyAccountSelectbyID = () => {
        if (this.state.workObject.idPartyAccount > 0) {
            this.accountTransactionServices.getPartyAccountSelectbyID(this.state.workObject.idPartyAccount).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    //debugger;
                    let data = this.state.workObject;
                    //data.modeOfPayment = res.paymentTerms;
                    data.address = res.p_Address;
                    data.email = res.emailID; //  data.inwardType?.find(item => item.name === res.invoiceType)?.id;
                    data.contactNo = res.contactNo;
                    data.contactPerson = res.contactPerson;
                    this.setState({ workObject: data });
                }
            });
        }
    }

    getTaxStructureSelectbyID = () => {
        if (this.state.itemObject.idTaxGroup > 0) {
            this.accountTransactionServices.getTaxStructureSelectbyID(this.state.itemObject.idTaxGroup).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    let data = this.state.itemObject;
                    data.sgst = res.sgst;
                    data.cgst = res.cgst;
                    data.igst = res.igst;
                    this.setState({ itemObject: data }, () => {
                        // this.calculatePricing();
                    });
                }
            });
        }
    }

    openPopUpFromURLId = (id) => {
        // clear urlId so the post-save redirect (to ledger-report) doesn't misfire
        this.setState({ urlId: 0 });
        this.getWorkOrderRecvSelectbyId(id);
    }

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getWorkOrderRecvSelectbyId(event.data.idwoOrderRecv);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForWork = () => {
        const newValidState = isValidForm(
            this.state.workObject,
            this.state.validationRulesForWork,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForWork = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.workObject;
        details[name] = value;
        this.setState({ workObject: details });
    }

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details }, () => {
            this.calculatePricing();
        });
    }

    handleChangeForPayment = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.paymentDetails;
        details[name] = value;
        this.setState({ paymentDetails: details }, () => {
            this.finalCalculation()
        });
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let workObject = this.state.workObject;
        let paymentDetails = this.state.paymentDetails
        workObject.idWOOrderRecv = ''
        workObject.deliveryDate = '';
        workObject.idPartyAccount = '';
        workObject.idDelivery = '';
        workObject.personName = '';
        workObject.address = "";
        workObject.delAdress = "";
        workObject.idEmployee = "";
        workObject.transporter = "";
        workObject.poNo = "";
        workObject.poDate = "";

        paymentDetails.totalQty = "";
        paymentDetails.totalAmt = "";
        paymentDetails.extraCharges = "";
        paymentDetails.disAmt = "";
        paymentDetails.taxableAmt = "";
        paymentDetails.taxAmt = "";
        paymentDetails.totalWithTax = "";
        paymentDetails.adjustableAmt = "";
        paymentDetails.finalAmt = "";
        this.setState({
            validState: validState,
            workObject: workObject,
            paymentDetails: paymentDetails
        });
    }

    handleChangeForDropdown = (event, name) => {
        let details = this.state.workObject;
        let value = event.value;
        details[name] = value;
        if (name === 'idDelivery') {
            details.delAdress = event.partyAddress
        }
        if (name === 'idPartyAccount') {
            details.delAdress = event.partyAddress
            details.idDelivery = event.value
            details.address = event.partyAddress
        }
        this.setState({ workObject: details }, () => {
            if (name === 'idPartyAccount') {
                this.getMasterItemSelectbyIDVendorwiseRateForWoOrderRecv()
            }
        });
    }

    handleChangeForDropdownForProductObject = (event, name) => {
        let details = this.state.itemObject;
        let value = event.value;
        details[name] = value;
        this.setState({ itemObject: details }, () => {
            if (name === 'idCategory') {
                let details = this.state.itemObject
                details.itemIdLabel = ''
                details.idItem = 0
                this.setState({ itemObject: details })
                this.getMasterItemSelectbyIDVendorwiseRateForWoOrderRecv()
            } else if (name === 'idItem') {
                this.getMasterItemSelectbyIDVendorwiseRate()
            } else if (name === 'idTaxGroup') {
                this.getTaxStructureSelectbyID()
            }
        });
    }

    handleOnClick = () => {
        this.setOpenModel2();
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.itemObject;
        data.idItem = event.data.idItem;
        data.itemIdLabel = event.data.itemName;
        this.setState({ itemObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp }, () => {
            this.getMasterItemSelectbyIDVendorwiseRate()
        });
    };

    calculatePricing = () => {
        if (this.state.itemObject.rate && this.state.itemObject.quantity) {
            let itemObject = { ...this.state.itemObject };
            let qty = parseFloat(itemObject.quantity);
            let rate = parseFloat(itemObject.rate);

            let amount = qty * rate;
            itemObject.amount = amount.toFixed(2);

            let discountPercent = parseFloat(itemObject.discount) || 0;
            let discountAmt = (amount * discountPercent) / 100;
            itemObject.discountAmt = discountAmt.toFixed(2);

            let chargeAmt = parseFloat(itemObject.chargeAmt) || 0;
            let total = amount - discountAmt + chargeAmt;
            itemObject.total = total.toFixed(2);

            let sgst = parseFloat(itemObject.sgst) || 0;
            let cgst = parseFloat(itemObject.cgst) || 0;
            let igst = parseFloat(itemObject.igst) || 0;

            let sgstAmt = this.state.workObject.idWoType === 1 ? (total * sgst / 100) : 0;
            let cgstAmt = this.state.workObject.idWoType === 1 ? (total * cgst / 100) : 0;
            let igstAmt = this.state.workObject.idWoType === 1 ? 0 : (total * igst / 100);

            itemObject.sgstAmt = sgstAmt.toFixed(2);
            itemObject.cgstAmt = cgstAmt.toFixed(2);
            itemObject.igstAmt = igstAmt.toFixed(2);

            let taxAmt = sgstAmt + cgstAmt + igstAmt;
            itemObject.taxAmt = taxAmt.toFixed(2);

            itemObject.netTotal = (total + taxAmt).toFixed(2);

            this.setState({ itemObject });
        }
    };

    insert = (flag) => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            if (flag === 'Insert') {
                //debugger;
                let details = this.state.itemObject;
                let itemList = [...this.state.itemRowData];
                let obj = {
                    idWOOrderRecvItems: 0,
                    drawingNo: details.drawingNo,
                    itemType: details.itemCategoryList.find(x => x.value === details.idCategory)?.label,
                    idCategory: details.idCategory,
                    idItem: details.idItem,
                    itemName: details.itemIdLabel,
                    quantity: Number(details.quantity),
                    rate: details.rate,
                    amount: Number(details.amount),
                    discount: Number(details.discount),
                    discountAmt: Number(details.discountAmt),
                    extraCharges: Number(details.chargeAmt),
                    total: Number(details.total),
                    idTaxGroup: details.idTaxGroup,
                    sgst: details.sgst,
                    sgstAmt: Number(details.sgstAmt),
                    cgst: details.cgst,
                    cgstAmt: Number(details.cgstAmt),
                    igst: details.igstAmt > 0 ? details.igst : 0,
                    igstAmt: Number(details.igstAmt),
                    netTotal: Number(details.netTotal).toFixed(2),
                    remarks: details.remarks,
                }
                itemList.push(obj);
                itemList.map((x, key) => {
                    x.keyId = key + 1;
                });
                this.setState({ itemRowData: itemList }, () => {
                    this.resetItemObject();
                    this.finalCalculation();
                });
            }
            else if (flag === 'Update') {
                let details2 = this.state.itemObject;
                let itemList2 = [...this.state.itemRowData];
                let obj2 = {
                    idWOOrderRecvItems: details2.idWOOrderRecvItems,
                    drawingNo: details2.drawingNo,
                    itemType: details2.itemCategoryList.find(x => x.value === details2.idCategory)?.label,
                    idCategory: details2.idCategory,
                    idItem: details2.idItem,
                    itemName: details2.itemIdLabel,
                    quantity: Number(details2.quantity),
                    rate: Number(details2.rate),
                    amount: Number(details2.amount),
                    discount: Number(details2.discount),
                    discountAmt: Number(details2.discountAmt),
                    extraCharges: Number(details2.chargeAmt),
                    total: Number(details2.total),
                    idTaxGroup: details2.idTaxGroup,
                    sgst: details2.sgst,
                    sgstAmt: Number(details2.sgstAmt),
                    cgst: details2.cgst,
                    cgstAmt: Number(details2.cgstAmt),
                    igst: details2.igstAmt > 0 ? details2.igst : 0,
                    igstAmt: Number(details2.igstAmt),
                    netTotal: Number(details2.netTotal).toFixed(2),
                    remarks: details2.remarks,
                };
                itemList2[details2.keyId - 1] = obj2;
                itemList2.map((x, key) => {
                    x.keyId = key + 1;
                });
                this.setState({ itemRowData: itemList2 }, () => {
                    this.resetItemObject();
                    this.finalCalculation();
                });
            }
        } else {
            this.SwalServices.Alert("Please Enter Valid Data");
        }
    }

    resetItemObject = () => {
        let itemObject = this.state.itemObject
        itemObject.idWOOrderRecvItems = 0
        itemObject.drawingNo = ""
        itemObject.idCategory = 1
        itemObject.idItem = ""
        itemObject.itemIdLabel = ""
        itemObject.unit = ""
        itemObject.quantity = ""
        itemObject.rate = ""
        itemObject.amount = ""
        itemObject.discount = ""
        itemObject.discountAmt = ""
        itemObject.chargeAmt = ""
        itemObject.total = ""
        itemObject.idTaxGroup = ""
        itemObject.sgst = ""
        itemObject.cgst = ""
        itemObject.igst = ""
        itemObject.sgstAmt = ""
        itemObject.cgstAmt = ""
        itemObject.igstAmt = ""
        itemObject.taxAmt = ""
        itemObject.netTotal = ""
        itemObject.keyId = ""
        itemObject.remarks = ""
        this.setState({ itemObject: itemObject, validState: { isValid: true, error: {} } });
    }

    finalCalculation = () => {
        const data = this.state.itemRowData;
        const finalAmountCal = {
            totalQty: 0,
            totalAmt: 0,
            extraCharges: 0,
            disAmt: 0,
            taxAmt: 0,
            totalWithTax: 0,
            finalAmt: 0,
            taxableAmt: 0
        };

        data.forEach((x) => {
            const quantity = Number(x.quantity) || 0;
            const amount = Number(x.amount) || 0;
            const extraCharges = Number(x.extraCharges) || 0;
            const sgst = Number(x.sgstAmt) || 0;
            const cgst = Number(x.cgstAmt) || 0;
            const igst = Number(x.igstAmt) || 0;
            const netTotal = Number(x.netTotal) || 0;
            const discountAmt = (amount * x.discount) / 100;

            const tax = sgst + cgst + igst;
            const totalBeforeTax = amount - discountAmt + extraCharges;
            const totalWithTax = totalBeforeTax + tax;

            finalAmountCal.totalQty += quantity;
            finalAmountCal.totalAmt += amount;
            finalAmountCal.extraCharges += extraCharges;
            finalAmountCal.disAmt += discountAmt;
            finalAmountCal.taxAmt += tax;
            finalAmountCal.totalWithTax += totalWithTax;
            finalAmountCal.finalAmt += netTotal;
            finalAmountCal.taxableAmt += Number(x.total)
        });

        // Format values
        finalAmountCal.totalAmt = finalAmountCal.totalAmt.toFixed(2);
        finalAmountCal.extraCharges = finalAmountCal.extraCharges.toFixed(2);
        finalAmountCal.disAmt = finalAmountCal.disAmt.toFixed(2);
        finalAmountCal.taxableAmt = Number(finalAmountCal.taxableAmt).toFixed(2)
        finalAmountCal.taxAmt = finalAmountCal.taxAmt.toFixed(2);
        finalAmountCal.totalWithTax = finalAmountCal.totalWithTax.toFixed(2);
        finalAmountCal.finalAmt = Math.round(finalAmountCal.finalAmt + (Number(this.state.paymentDetails.adjustableAmt) || 0));
        finalAmountCal.adjustableAmt = this.state.paymentDetails.adjustableAmt

        this.setState({ paymentDetails: finalAmountCal });
    };

    handleCellClickItemList = (event) => {
        let data = [...this.state.itemRowData];
        let getItemData = data[event.data.keyId - 1];
        let details = this.state.itemObject;
        details.idWOOrderRecvItems = getItemData.idWOOrderRecvItems;
        details.drawingNo = getItemData.drawingNo
        details.idCategory = getItemData.idCategory
        details.idItem = getItemData.idItem
        details.itemIdLabel = getItemData.itemName
        details.unit = getItemData.unit
        details.quantity = getItemData.quantity
        details.rate = getItemData.rate
        details.amount = getItemData.amount
        details.discount = getItemData.discount
        details.discountAmt = getItemData.discountAmt
        details.chargeAmt = getItemData.extraCharges
        details.total = getItemData.total
        details.idTaxGroup = getItemData.idTaxGroup
        details.sgst = getItemData.sgst
        details.cgst = getItemData.cgst
        details.igst = getItemData.igst
        details.sgstAmt = getItemData.sgstAmt
        details.cgstAmt = getItemData.cgstAmt
        details.igstAmt = getItemData.igstAmt
        details.taxAmt = getItemData.taxAmt
        details.netTotal = getItemData.netTotal
        details.remarks = getItemData.remarks;
        details.keyId = getItemData.keyId;
        details.isDeliveryChallanEntryExists = getItemData.isDeliveryChallanEntryExists;
        details.isMaterialPlanningEntryExists = getItemData.isMaterialPlanningEntryExists;
        this.setState({ itemObject: details });
    };

    deleteItem = (keyId) => {
        let data = this.state.itemObject;
        let idWOOrderRecvItems = this.state.itemRowData?.find(item => item.keyId == keyId)?.idWOOrderRecvItems;
        let filterData = this.state.itemRowData?.filter(item => item.keyId !== keyId);
        if (filterData.length > 0) {
            filterData.map((x, key) => {
                x.keyId = key + 1;
            });
        }
        //data.itemList = filterData;
        if (idWOOrderRecvItems > 0) {
            data.deleteItemsList.push(idWOOrderRecvItems);
        }
        this.setState({ itemObject: { ...data }, itemRowData: filterData }, () => {
            this.resetItemObject();
            this.finalCalculation();
        });
    }

    submit = () => {
        if (this.isSubmitting) { return; }
        if (this.state.isChallanGenerated) {
            this.SwalServices.Alert("A delivery challan has already been generated for this work order, so it can no longer be edited.");
            return;
        }
        if (this.state.itemRowData.length === 0) {
            this.SwalServices.Alert("Please add product items details");
        } else {
            const isValidAllFields = this.isValidAllFieldsForWork();
            if (isValidAllFields) {
                let data = this.state.workObject
                let itemObject = this.state.itemObject;
                let paymentDetails = this.state.paymentDetails;
                let request = {
                    idWOOrderRecv: data.idWOOrderRecv,
                    updateStatus: data.updateStatus,
                    transporter: data.transporter,
                    woRecvNo: data.woRecvNo,
                    woRecvDate: data.woRecvDate,
                    idPartyAccount: data.idPartyAccount,
                    woType: data.woTypeList.find(x => x.value === data.idWoType)?.label,
                    woCategory: data.categoryList.find(x => x.value === data.idCategory)?.label,
                    deliveryDate: data.deliveryDate && data.deliveryDate !== 'Invalid date' ? data.deliveryDate : null,
                    idDelivery: data.idDelivery,
                    poNo: data.poNo,
                    poDate: data.poDate && data.poDate !== 'Invalid date' ? data.poDate : null,
                    personName: data.personName,
                    idEmployee: data.idEmployee,
                    priority: data.WoPrioratyList.find(x => x.value === data.idWoPrioraty)?.label,
                    totalQty: paymentDetails.totalQty,
                    totalAmt: paymentDetails.totalAmt,
                    taxAmt: paymentDetails.taxAmt,
                    totalWithTax: paymentDetails.totalWithTax,
                    extraCharges: paymentDetails.extraCharges,
                    discount: paymentDetails.disAmt,
                    finalAmt: paymentDetails.finalAmt,
                    remarks: data.remarks,
                    idCompany: this.state.idCompany,
                    e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
                    e_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                    isUpdated: data.updateStatus === 1 ? true : false,
                    updatedDate: data.updateStatus === 1 ? new Date().toISOString() : null,
                    u_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                    isDeleted: false,
                    deletedDate: null,
                    d_IDUser: null,
                    prefix: data.prefix,
                    isClosed: data.isClose,
                    tcsPercentage: data.tcsPercentage,
                    tcsAmt: data.tcsAmt,
                    idFinancialYear: data.idFinancialYear,
                    adjustableAmt: paymentDetails.adjustableAmt,
                    taxableAmt: paymentDetails.taxableAmt
                };
                request.deleteItemsList = itemObject.deleteItemsList;
                request.itemList = [];
                let itemList = this.state.itemRowData;
                itemList.map((details) => {
                    let obj = {
                        idWOOrderRecvItems: details.idWOOrderRecvItems,
                        idWOOrderRecv: data.idWOOrderRecv,
                        drawingNo: details.drawingNo,
                        itemType: itemObject.itemCategoryList.find(x => x.value === details.idCategory)?.label,
                        idItem: details.idItem,
                        quantity: details.quantity,
                        rate: details.rate,
                        amount: details.amount,
                        total: details.total,
                        discount: details.discount,
                        extraCharges: details.extraCharges,
                        taxableAmt: details.total,
                        sgst: details.sgst,
                        sgstAmt: details.sgstAmt,
                        cgst: details.cgst,
                        cgstAmt: details.cgstAmt,
                        igst: details.igst,
                        igstAmt: details.igstAmt,
                        netTotal: details.netTotal,
                        idTaxGroup: details.idTaxGroup,
                        itemRemarks: details.remarks,
                    }
                    request.itemList.push(obj);
                });
                this.isSubmitting = true;
                this.setState({ isSaving: true });
                this.transactionStockServices.submitWorkOrderRecv(request).then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let data = response.responseItem.responseContent;
                        if (data !== null) {
                            if (this.state.workObject.updateStatus === 1) {
                                this.SwalServices.Success("Updated sucessfully.");
                            } else {
                                this.SwalServices.Success("Save sucessfully.");
                            }
                            if (this.state.urlId) {
                                this.setState({ route: '/ledger-report' });
                            } else {
                                this.setState({
                                    isModalOpen: false,
                                }, () => {
                                    this.resetDetailsFields();
                                    this.resetItemObject();
                                    this.procSelectAllRecordsSP();
                                });
                            }
                        }
                    }
                }).finally(() => { this.isSubmitting = false; this.setState({ isSaving: false }); });
            }
        }
    }

    getWorkOrderRecvSelectbyId = (idWOOrderRecv) => {
        if (idWOOrderRecv > 0) {
            this.transactionStockServices.getWorkOrderRecvSelectbyId(idWOOrderRecv).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let itemListRecords = response.responseItem.responseContent[1];
                    let itemList = [];
                    let workObject = this.state.workObject;
                    let paymentDetails = this.state.paymentDetails;
                    // 'Status' = 'YES' when a delivery challan already exists for this WO -> lock Save
                    this.setState({ isChallanGenerated: (res.status || '').toUpperCase() === 'YES' });
                    workObject.idWOOrderRecv = res.idwoOrderRecv;
                    workObject.updateStatus = 1;
                    workObject.woRecvNo = res.woRecvNo
                    workObject.woRecvDate = res.woRecvDate ? moment(res.woRecvDate).format('YYYY-MM-DD') : null;
                    workObject.idCategory = res.woCategory ? workObject.categoryList.find(x => x.label === res.woCategory)?.value : 1;
                    workObject.idWoType = res.woType ? workObject.woTypeList.find(x => x.label === res.woType)?.value : 1;
                    workObject.deliveryDate = res.deliveryDate ? moment(res.deliveryDate).format('YYYY-MM-DD') : '';
                    workObject.idPartyAccount = res.idPartyAccount;
                    workObject.idDelivery = res.idDelivery;
                    workObject.personName = res.personName
                    workObject.idWoPrioraty = res.priority ? workObject.WoPrioratyList.find(x => x.label === res.priority)?.value : 2;
                    workObject.address = res.idPartyAccount ? workObject.customerList.find(x => x.value === res.idPartyAccount)?.partyAddress : "";
                    workObject.delAdress = res.idDelivery ? workObject.deliveryList.find(x => x.value === res.idDelivery)?.partyAddress : "";
                    workObject.idEmployee = res.idEmployee ? res.idEmployee : 0;
                    workObject.transporter = res.transporter ? res.transporter : "";
                    workObject.poNo = res.poNo;
                    workObject.poDate = res.poDate ? moment(res.poDate).format('YYYY-MM-DD') : '';
                    workObject.e_Date = res.e_Date;
                    paymentDetails.totalQty = res.totalQty;
                    paymentDetails.totalAmt = res.totalAmt;
                    paymentDetails.extraCharges = res.extraCharges;
                    paymentDetails.disAmt = Number(res.discount);
                    paymentDetails.taxAmt = res.taxAmt;
                    paymentDetails.totalWithTax = res.totalWithTax;
                    paymentDetails.finalAmt = res.finalAmt;
                    paymentDetails.adjustableAmt = res.adjustableAmt;
                    paymentDetails.taxableAmt = res.taxableAmt;

                    itemListRecords.map((details, keyId) => {
                        let obj = {
                            idWOOrderRecvItems: details.idwoOrderRecvItems,
                            drawingNo: details.drawingNo,
                            idCategory: this.state.itemObject.itemCategoryList?.find(x => x.label === details.itemType)?.value,
                            itemType: details.itemType ? details.itemType : "",
                            idItem: details.idItem ? details.idItem : 0,
                            itemIdLabel: details.itemName ? details.itemName : "",
                            itemName: details.itemName ? details.itemName : "",
                            unit: details.unit ? details.unit : "",
                            quantity: details.quantity ? details.quantity : 0,
                            rate: details.rate ? details.rate : 0,
                            amount: details.amount ? details.amount : 0,
                            discount: details.discount ? details.discount : 0,
                            discountAmt: details.discountAmt ? details.discountAmt : 0,
                            extraCharges: details.extraCharges ? details.extraCharges : 0,
                            total: details.taxableAmt ? details.taxableAmt : 0,
                            idTaxGroup: details.idTaxGroup ? details.idTaxGroup : 0,
                            sgst: details.sgst,
                            cgst: details.cgst,
                            igst: details.igst,
                            sgstAmt: details.sgstAmt,
                            cgstAmt: details.cgstAmt,
                            igstAmt: details.igstAmt,
                            taxAmt: details.taxAmt,
                            netTotal: details.netTotal,
                            remarks: details.itemRemarks,
                            keyId: keyId + 1,
                            isMaterialPlanningEntryExists: details.isMaterialPlanningEntryExists,
                            isDeliveryChallanEntryExists: details.isDeliveryChallanEntryExists
                        }
                        itemList.push(obj);
                    })
                    this.setState({ workObject: workObject, paymentDetails: paymentDetails, itemRowData: itemList, isModalOpen: true, globalUserID: res.modifiedBy }, () => {
                        this.finalCalculation()
                        this.getPartyAccountSelectbyID()
                    });
                }
            });
        }
    }

    generateWoOrderInvoice = () => {
        if (this.state.workObject.idWOOrderRecv > 0) {
            let request = [this.state.workObject.idWOOrderRecv];
            this.transactionStockServices.downloadWoOrderInvoice(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    var filename = `PurchaseInvoice-${moment(new Date()).format("DDMMYYYYHHmmss")}`;
                    var file = new Blob([response.data], { type: "application/pdf" });

                    var fileURL = URL.createObjectURL(file);

                    window.open(fileURL, "_blank");

                    this.setState({
                        isModalOpen: false
                    });
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    generatePendingWoOrderInvoice = () => {
        if (this.state.workObject.idWOOrderRecv > 0) {
            let request = [this.state.workObject.idWOOrderRecv];
            this.transactionStockServices.DownloadPendingWoOrderInvoice(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    var filename = `PendingPurchaseInvoice-${moment(new Date()).format("DDMMYYYYHHmmss")}`;
                    var file = new Blob([response.data], { type: "application/pdf" });

                    var fileURL = URL.createObjectURL(file);

                    window.open(fileURL, "_blank");

                    this.setState({
                        isModalOpen: false
                    });
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    shareOnWhatsApp = () => {
        if (this.state.workObject.idWOOrderRecv > 0) {
            let request = [
                this.state.workObject.idWOOrderRecv,
                "WorkOrderInvoices"
            ];
            this.transactionStockServices.shareOnWhatsApp(request).then((response) => {
                if (response.statusCode == 200 && response !== null) {
                    if (response.responseItem.responseContent) {
                        const link = response.responseItem.responseContent;
                        const phoneNumber = this.state.workObject?.contactNo || "";
                        const message = `Dear Customer ${this.state.workObject?.contactPerson || ""},  
                                        -> Please find attached your Work Order.  
                                        -> You can view or download it using the link below:    
                                        -> ${link}  
                                        
                                        Thank you for your business!`;
                        const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                        window.open(whatsappLink, "_blank");
                    } else {
                        this.SwalServices.Error("No data found");
                    }
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }

    };

    sendOnEmail = () => {
        if (this.state.workObject.idWOOrderRecv && this.state.workObject.email) {
            let request = [
                this.state.workObject.email,
                this.state.workObject.idWOOrderRecv,
                this.state.companyName,
                "WorkOrderInvoices"
                //"InvoiceTempletes\\PurchaseOrderInvoices"
            ];
            this.transactionStockServices.sendPurchaseInvoiceMail(request).then((response) => {
                if (response.responseItem !== null && response.statusCode === 200) {
                    this.SwalServices.Success("Invoice snet sucessfully.");
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        } else {
            this.SwalServices.Error("No data found");
        }
    };


    render() {
        return (
            <>
                <div className='manual-invoice'>
                    <div className='data-display'>
                        <div className='data-display-inner relative'>
                            <ButtonGrp buttons={['add', 'print']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddingItem(),
                                    // update: () => this.openPopUpForUpdateItem(),
                                    print: this.handlePrint,
                                }}
                            />
                            <WoOrderReceivePopup
                                isModalOpen={this.state.isModalOpen}
                                setOpenModel={this.setOpenModel.bind(this)}
                                workObject={this.state.workObject}
                                itemObject={this.state.itemObject}
                                handleChangeForWork={this.handleChangeForWork.bind(this)}
                                handleChangeForPayment={this.handleChangeForPayment.bind(this)}
                                handleChange={this.handleChange.bind(this)}
                                onGridReady={this.onGridReady.bind(this)}
                                close={this.closePopup.bind(this)}
                                submit={this.submit.bind(this)}
                                isChallanGenerated={this.state.isChallanGenerated}
                                isSaving={this.state.isSaving}
                                validState={this.state.validState}
                                itemRowData={this.state.itemRowData}
                                itemColdefs={this.state.itemColdefs}
                                handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                                handleChangeForDropdownForProductObject={this.handleChangeForDropdownForProductObject.bind(this)}
                                handleOnClick={this.handleOnClick.bind(this)}
                                insert={this.insert.bind(this)}
                                paymentDetails={this.state.paymentDetails}
                                handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                                clear={this.resetItemObject.bind(this)}
                                delete={this.deleteItem.bind(this)}
                                sendOnEmail={this.sendOnEmail.bind(this)}
                                shareOnWhatsApp={this.shareOnWhatsApp.bind(this)}
                                generateWoOrderInvoice={this.generateWoOrderInvoice.bind(this)}
                                generatePendingWoOrderInvoice={this.generatePendingWoOrderInvoice.bind(this)}
                                usp_Users={this.state.usp_Users}
                                globalUserID={this.state.globalUserID}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">WO order receive</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        onGridReady={this.onGridReady}
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                        onCellClicked={this.handleCellClick}
                                    />
                                </div>
                            </div>

                            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                    <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.table2Data}
                                        columnDefs={this.state.table2ColDefs}
                                        rowHeight={this.state.rowHeight}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onGridReady={this.onGridReady}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.itemObject.itemList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    //handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
            </>
        )
    }
}
